module.exports = __webpack_public_path__ + "img/15-6.04ab71bb.jpg";